import script from "./ModalAntecedentes.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalAntecedentes.vue?vue&type=script&setup=true&lang=js"

import "./ModalAntecedentes.vue?vue&type=style&index=0&id=22d3f6c0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22d3f6c0"]])

export default __exports__